<button type="button" class="btn btn-link modal-close" (click)="cancel()">
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 6L6 18"
      stroke="#03101F"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 6L18 18"
      stroke="#03101F"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</button>
<h6 class="change-package-heading mb-0 pb-0 mt-2 ms-4" mat-dialog-title>
  <span class="py-3 px-0">Change Package</span>
</h6>
 <div class="mb-0 p-0 border-top-gray" [ngClass]="{'edit-change-package-table' : isEdit}">
  <app-package
    [openedFrom]="3"
    [selectedPackage]="selectedPackage"
    (packageAssigned)="receivedPackage($event)"
    [isCurrentTab]="activeTab"
  ></app-package>
  <div class="row mx-0 swap-package-notes">
    <div class="col-sm-12">
      <div class="notes-section">
        <label class="black-text fs-14 mb-1">Notes</label>
        <textarea
          [required]="true"
          class="form-control custom-textarea"
          rows="3"
          aria-placeholder="Name"
          placeholder="Enter your notes here"
          [(ngModel)]="notes"
        ></textarea>
      </div>
    </div>
  </div>
  <div class="col-sm-12 text-end swap-package-footer">
    <div class="mt-0 mt-sm-0 pt-0 pt-sm-0">
      <button
        type="button"
        class="btn theme-btn cursor-pointer"
        (click)="swapPackage()"
      >
        Upgrade Package
      </button>
    </div>
  </div>
</div>
